document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let topContentSlider = new Swiper('.top-content__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    });

    let singleSlider = new Swiper('.slider__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }
    });

     let reviewSlider = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween: 20,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        }
    });

    let gallerySlider = new Swiper('.gallery-home__slider',{
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween: 20,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
        ,
        navigation: {
            prevEl: '.gallery-home-prev',
            nextEl: '.gallery-home-next'
        }
    });

    let galleryDefaultSlider = new Swiper('.gallery-default__slider',{
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween: 20,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-default-prev',
            nextEl: '.gallery-default-next'
        }
    });

    let cardsSlider = new Swiper('.cards__slider',{
        loop: true,
        speed: 700,
        slidesPerView:1,
        spaceBetween: 20,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        }

    });
    

});